import './advanced-order-task-spec-form/advanced-order-task-spec-form.component';
import './advanced-order-task-spec-form/advanced-order-task-spec-form.scss';

import './complete-selected-tasks-dialog/complete-selected-tasks-dialog.component';

import './internal-task-item/internal-task-item.component';
import './internal-task-item/internal-task-item.scss';

import './pod-items/pod-items.component';
import './pod-items/pod-items.scss';

import './task-bundle-item/task-bundle-item.component';
import './task-bundle-item/task-bundle-item.scss';

import './task-capacity-bars/task-capacity-bars.component';
import './task-capacity-bars/task-capacity-bars.scss';

import './task-eta/task-eta.component';
import './task-eta/task-eta.scss';

import './task-eta-by-status/task-eta-by-status.component';
import './task-eta-by-status/task-eta-by-status.scss';

import './task-eta-text/task-eta-text.component';
import './task-eta-text/task-eta-text.scss';

import './task-info/task-info.component';
import './task-info/task-info.scss';

import './task-info-button/task-info-button.component';
import './task-info-button/task-info-button.scss';

import './task-info-card/task-info-card.component';
import './task-info-card/task-info-card.scss';

import './task-item/task-item.component';
import './task-item/task-item.scss';

import './task-itinerary-print-info/task-itinerary-print-info.component';
import './task-itinerary-print-info/task-itinerary-print-info.scss';

import './task-itinerary-print-item/task-itinerary-print-item.component';
import './task-itinerary-print-item/task-itinerary-print-item.scss';

import './task-mini-card/task-mini-card.component';
import './task-mini-card/task-mini-card.scss';

import './task-note-info-icon/task-note-info-icon.component';
import './task-note-info-icon/task-note-info-icon.scss';

import './task-packages-print-item/task-packages-print-item.component';
import './task-packages-print-item/task-packages-print-item.scss';

import './task-planned-eta/task-planned-eta.component';
import './task-planned-eta/task-planned-eta.scss';

import './task-print-info/task-print-info.component';
import './task-print-info/task-print-info.scss';

import './task-purpose/task-purpose.component';
import './task-purpose/task-purpose.scss';

import './task-purpose-icon/task-purpose-icon.component';
import './task-purpose-icon/task-purpose-icon.scss';

import './task-relation-card/task-relation-card.component';
import './task-relation-card/task-relation-card.scss';

import './task-relation-type-select/task-relation-type-select.component';
import './task-relation-type-select/task-relation-type-select.scss';

import './relation-type-multi-select-list/relation-type-multi-select-list.component';
import './relation-type-multi-select-list/relation-type-multi-select-list.scss';

import './relation-type-display-list/relation-type-display-list.component';
import './relation-type-display-list/relation-type-display-list.scss';

import './task-service-time-quick-edit-field/task-service-time-quick-edit-field.component';
import './task-service-time-quick-edit-field/task-service-time-quick-edit-field.scss';

import './task-spec-customers-form/task-spec-customers-form.component';
import './task-spec-customers-form/task-spec-customers-form.scss';

import './task-status/task-status.component';
import './task-status/task-status.scss';

import './task-status-icon/task-status-icon.component';
import './task-status-icon/task-status-icon.scss';

import './task-summery-line/task-summery-line.component';
import './task-summery-line/task-summery-line.scss';

import './task-approval-status-multi-select-list/task-approval-status-multi-select-list.component';
import './task-approval-status-multi-select-list/task-approval-status-multi-select-list.scss';

import './task-approval-status-multi-select/task-approval-status-multi-select.component';
import './task-approval-status-multi-select/task-approval-status-multi-select.scss';

import './tasks-offline-actions-table/tasks-offline-actions-table.component';
import './tasks-offline-actions-table/tasks-offline-actions-table.scss';

import './tasks-offline-actions-table-row/tasks-offline-actions-table-row.component';
import './tasks-offline-actions-table-row/tasks-offline-actions-table-row.scss';


